// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TradeWebTop_wrapper__gVXmz","orderBook":"TradeWebTop_orderBook__BMSDL","buyAndSell":"TradeWebTop_buyAndSell__AFdW_"};